import { Showroom, getStaticProps } from '@public/Showroom'

export { getStaticProps }

export default Showroom
